/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { GeoProvincesByRegionResponse } from '../../models/geo-provinces-by-region-response';

export interface GeoControllerGetProvincesByRegion$Params {
  id: number;
}

export function geoControllerGetProvincesByRegion(http: HttpClient, rootUrl: string, params: GeoControllerGetProvincesByRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoProvincesByRegionResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, geoControllerGetProvincesByRegion.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: GeoProvincesByRegionResponse;
      }>;
    })
  );
}

geoControllerGetProvincesByRegion.PATH = '/geo/italy/region/{id}/province';
